/* eslint no-useless-escape: 0 */

const pe = "\nThe tinfoil\n Between your teeth is sparking \n You\'re biting your nails again \n But oh my darling \n suspense can be suffocating \n But you could learn so much from it \n We\'ll learn in time what is truly sacred \n It won\'t have to be pointed out \n And if it\'s like that with you \n Imagine how we feel \n Sitting on our hands \n Lightning under my fingernails \n You weren\'t impressed now, baby";

export default pe;
